import { render } from "./StatusUpdate.vue?vue&type=template&id=23279cc3&scoped=true"
import script from "./StatusUpdate.vue?vue&type=script&lang=js"
export * from "./StatusUpdate.vue?vue&type=script&lang=js"

import "./StatusUpdate.vue?vue&type=style&index=0&id=23279cc3&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23279cc3"]])

export default __exports__